import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import {amber, green} from "@material-ui/core/colors";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
    root: {
    },
    inline: {
        display: 'inline',
    },
    green: {
        color: '#fff',
        backgroundColor: green[500],
    },
    amber: {
        color: '#fff',
        backgroundColor: amber[500],

    }
}));

export default function Anuncios() {
    const classes = useStyles();
    const [anuncios, setAnuncios] = useState([
        {
            read: true,
            date: "06/10/2021 ",
            title: "Mensaje de Bienvenida UVT",
            message: "Bienvenidos a este nuevo ciclo escolar. Estamos emocionados de empezar esta nueva aventura juntos, aventura en la que hemos invertido muchas horas pensando en la mejor manera de transmitir los conocimientos necesarios en el área laboral, a través de las aulas"
        },
        {
            read: false,
            date: "06/10/2021 ",
            title: "Fecha límite para entrega de Servicio Social",
            message: "Se les recuerda al alumnado en general que la próxima semana es el último día para recibir las constancias que acrediten las horas de Servicio Social realizadas durante el último ciclo escolar"
        },
        {
            read: false,
            date: "06/10/2021 ",
            title: "Asueto por el día de los padres",
            message: "Se le notifica al alumnado en general que el próximo fin de semana no laborará el personal administrativo. Agradecemos de antemano su comprensión y paciencia."
        },
    ]);
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    const handleClickOpen = (index) => {
        setIndex(index)
        setOpen(true);
    };

    const handleClose = e => {
        if (e.currentTarget.value) {
            const value = e.currentTarget.value === "false" ? false : Boolean(e.currentTarget.value);
            setAnuncios([
                ...anuncios.slice(0, index),
                {
                    ...anuncios[index],
                    read: value
                },
                ...anuncios.slice(index + 1),
            ]);
        }
        setOpen(false);
    };

    return (
        <div>
            <Typography variant="h2">
                Anuncios
            </Typography>
            <List className={classes.root}>
                {anuncios.map((o, index) => (
                    <>
                        <ListItem alignItems="flex-start" onClick={() => handleClickOpen(index)}>
                            <ListItemAvatar>
                                {o.read
                                    ? <Avatar className={classes.green}>
                                        <CheckCircleIcon/>
                                    </Avatar>
                                    : <Avatar className={classes.amber}>
                                        <NotificationImportantIcon/>
                                    </Avatar>
                                }
                            </ListItemAvatar>
                            <ListItemText
                                primary={o.title}
                                secondary={
                                    <React.Fragment>
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            className={classes.inline}
                                            color="textPrimary"
                                        >
                                            {o.date}
                                        </Typography>
                                        {o.message}
                                    </React.Fragment>
                                }
                            />
                        </ListItem>
                        <Divider variant="inset" component="li"/>
                    </>
                ))}
            </List>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{anuncios[index].title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{anuncios[index].message}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary" value={false}>
                        Marcar como NO leído
                    </Button>
                    <Button onClick={handleClose} color="primary" value={true}>
                        Marcar como leído
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};